import { Interval, PlanV2 } from "@zapier/checkout/esm/types";

export const findPlans = (
  toPlanName: string,
  plans: PlanV2[],
  currentInterval: Interval
) => {
  const altInterval = currentInterval === "year" ? "month" : "year";
  const toPlanNameLower = toPlanName.toLowerCase();

  let toPlan = plans.find(
    p =>
      toPlanNameLower === p.name.toLowerCase() && currentInterval === p.interval
  );

  toPlan =
    toPlan ??
    plans.find(
      p =>
        toPlanNameLower === p.name.toLowerCase() && altInterval === p.interval
    );

  // The alternative interval plan for the selected plan
  const toPlanAlt = plans.find(
    p =>
      toPlanNameLower === p.name.toLowerCase() &&
      p.tasks === toPlan?.tasks &&
      p.zaps === toPlan?.zaps &&
      p.interval !== toPlan.interval
  );

  return [toPlan, toPlanAlt];
};
